import {GetStaticPropsContext} from 'next';
import React from 'react';

import {RENDER_MODES} from '@udemy/nextjs-core';
import {getBundleFromTopic} from '@udemy/react-certification-preparation';
import {udSentry} from '@udemy/sentry';

import {getLayout} from 'src/components/layout';
import {
    AllCertificationVouchersLandingPageFeature,
    AllCertificationVouchersLandingPageFeatureProps,
} from 'src/features/all-certification-vouchers-landing-page';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {getBundleCourseData} from 'src/lib/get-course-data';
import {getStaticAppContext} from 'src/pages/api/context.api';
import {AppContextData} from 'src/types/page-props';

const COMPTIA_SECURITY_TOPIC_SLUG = 'comptia-security';

export async function getStaticProps(context: GetStaticPropsContext) {
    const locale = context.locale as string;
    const translations = await getCompactTranslations(locale);
    const staticData = await getStaticAppContext({locale});
    const appContext: AppContextData = staticData;

    const certificationBundle = await (async () => {
        const bundle = getBundleFromTopic(COMPTIA_SECURITY_TOPIC_SLUG);
        if (bundle) {
            try {
                const courses = await getBundleCourseData(bundle.contents.map((c) => c.id));
                return {...bundle, contents: courses};
            } catch (error) {
                udSentry.captureException(error);
            }
        }

        return null;
    })();

    return {
        props: {
            appContext,
            locale,
            pageKey: 'all_certification_vouchers',
            renderMode: RENDER_MODES.ISR,
            translations,
            certificationBundle,
        },
        revalidate: FOUR_HOURS,
    };
}

export default function AllCertificationVouchersLandingPage(
    props: AllCertificationVouchersLandingPageFeatureProps,
) {
    return <AllCertificationVouchersLandingPageFeature {...props} />;
}

AllCertificationVouchersLandingPage.getLayout = getLayout;
